import { AnimateEngine } from './core/engine';
import { isThemeId, themes } from './themes/registry';
import type { AnimateInstance, AnimateOptions } from './core/types';

export type {
  Action,
  ThemeId,
  RyukAction,
  PainAction,
  AnimateEvent,
  AnimateInstance,
  AnimateOptions,
  AnimateSnapshot,
} from './core/types';
export const version = '0.1.0';

export function createAnimate(options: AnimateOptions = {}): AnimateInstance {
  if (!document.body)
    throw new Error('Animate: call createAnimate after the document body exists.');
  if (options.theme && !isThemeId(options.theme))
    throw new Error(`Animate: unknown theme "${options.theme}".`);
  return new AnimateEngine(themes[options.theme ?? 'naruto'], options);
}
